import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { User } from '@/type';

export const useUserRoleMapper = () => {
  const { t } = useTranslation();

  const mapUserRole = useCallback(
    (user: User | User['role']) => {
      const role = typeof user === 'string' ? user : user.role;
      switch (role) {
        case 'Admin':
          return 'Admin'; // 서비스에 노출시키지 않을 값
        case 'SiteAdmin':
          return t('role.siteAdmin.attemper');
        case 'Manager':
          return t('role.manager.nonresidenter');
        case 'Worker':
          return t('role.labeler.updelve');
        case 'Guest':
          return t('role.guest.hatbrush');
      }
    },
    [t],
  );

  return {
    mapUserRole,
  };
};
